import React, { useEffect, useState ,useRef} from "react";
import IranMap from "./assets/Iranmap.png"
import Location from "./assets/Location.svg"
import LocationGray from "./assets/Location-gray.svg"
import Ellipse from "./assets/Ellipse.svg"
import styled from "styled-components";
import "./css/cityLanding.css"
import Succes from "./assets/Succes.svg"

const Container = styled.div`
  width: 100% !important;
  min-height: 300px;
  height: auto;
  margin: 0;
  justify-content: center;
  align-items: center;
`;


const Title = styled.h2`
  font-weight: bold;
  display:block;
  text-align:center;
  font-size: 21px;
`;

const Text = styled.p`
    font-size: 16px;
    margin-top: 20px;
    color: #525256;  
    text-align:center;  
`;

const Content = styled.p`
    font-size: 16px;
    margin-top: 20px;
    color: #525256; 
    background-color:#ddd;
    display:block;
    padding:30px 40px;
    border-radius:20px;
    margin-left:auto;
    margin-right:auto;
    text-align:center;
`;

const Button = styled.button`
  background-color: #ccc;
  border-radius: 20px;
  width: 140px;
  padding: 10px;
  border: none;
  color: white;
`;

const Submit = styled.button`
//   background-color: linear-gradient(180deg, #F7B61D, #F7941D);
    background-color:#F7B61D;
  border-radius: 20px;
  width: 120px;
  padding: 10px;
  border: none;
  color: white;
`;

const Map = styled.img`
  width: 100%;
`;

const Icon = styled.img`
  width: 28px;
  padding:5px
`;

const Direction = styled.span`
    font-size: 14px !important;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 7px -6px #222;
    padding: 25px 30px;
`;

const DirectionText = styled.p`
    line-height:33px;
    margin-bottom:0;
`;

const Bold = styled.p`
    font-weight:bold;
    padding-bottom:0;
    display:inline;
`;

const Footer = styled.div`
    font-weight:bold;
    background-color: #3DC36D;
    min-height:150px;
    line-height:53px;
    padding:30px 40px;
    font-size:25px;
    text-align:center;
    color:#fff;
    @media (max-width: 325px) {
        font-size: 14px;
    }
    @media (max-width: 379px) {
        font-size: 20px;
    }
    @media (min-width: 379px) {
        font-size: 25px;
    }
`;

function CityLanding(){
    const [content, setContent]=useState("")
    const [submitOpen, setSubmitOpen] = useState(false)
    const myRef = useRef(null)

    return(<>
        {submitOpen ? 
            <div className="container d-flex justify-content-center align-items-center mt-30">
                <div className="d-flex justify-content-center align-items-center mt-15 p-5 row bg-white px-10"  ref={myRef} style={{boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px"}}>
                <img src={Succes} style={{width:"100px"}}></img>
                <div className="col-12 d-flex justify-content-center mt-5" style={{fontWeight:"bold",fontSize:"35px"}}><p className="mb-0">نظر شما با موفقیت ثبت شد.</p></div>
                <div className="col-12 d-flex justify-content-center mt-8">
                    <Button
                        className="col-3 my-2 p-5 "
                        style={{ backgroundColor:  "#3DC36D", borderRadius: "15px", fontSize: "large" }}
                    >
                        <a href="http://ebus.ir/activeCity"> <span className="mx-auto my-auto text-white">بازگشت </span></a>
                    </Button>
                </div>
                </div>
            </div>
        :
        <>
            <div className="container px-xl-40">
                <Container>
                    <div className='row'>
                        <div className="mt-10 col-12">
                            <Title style={{fontSize:"25px !important"}} >در کدام شهرها هستیم؟</Title>
                        </div>
                        <Content className="col-12">
                            ایباس به عنوان " اولین سامانه حمل و نقل هوشمند اتوبوسی " که در زمستان 1400 فعالیت خود را در مسیر<Bold>" رشت به تهران "</Bold> و <Bold>" تهران به رشت "</Bold> آغاز کرده است.  
                        </Content>
                        <div className="col-md-2"></div>
                        <div className="col-12 col-md-8">
                            <Map src={IranMap} className="p-5 p-lg-15 p-xl-20" />
                        </div>
                        <div className="row">
                            <Text className="col-12 px-md-25">در تلاش هستیم که به زودی فعالیت خود را در شهرهای مختلف گسترش دهیم تا مسافران اتوبوسی در تمام مراکز استان و شهرستانها از خدمات ایباس بهره مند شوند. </Text>
                        </div>
                        <div className="col-md-2"></div>

                        <div className="mt-17 col-12">
                            <Title >استان ها و مسیر های تحت پوشش ایباس</Title>
                        </div>
                        <Direction className="col-12 mt-17 mb-3">
                            <div className="row">
                                <span className="row col-lg-3 pl-12 px-lg-0">
                                    <Icon src={Location} />
                                    <DirectionText style={{fontWeight:"bold"}} >از استان گیلان (ترمینال رشت)</DirectionText>
                                </span>
                                <span className="d-none d-lg-block col-lg-6 mt-5" style={{width:"150px",borderTop:"1px #ccc dashed"}}></span>
                                <span className="d-block d-lg-none col-1 ml-12" style={{height:"7px",borderRight:"1px #ccc dashed"}}></span>
                                <div className="row col-lg-3" style={{marginRight:"auto"}}>
                                    <Icon src={Ellipse}/>
                                    <DirectionText>به استان تهران (ترمینال غرب)</DirectionText>
                                </div>
                            </div>
                            <Button className="ml-5 mt-5">مشاهده روی نقشه</Button>
                        </Direction>
                        <Direction className="col-12 mt-17 mb-3">
                            <div className="row">
                                <div className="row col-lg-3 pl-12 px-lg-0">
                                    <Icon src={Location} />
                                    <DirectionText style={{fontWeight:"bold"}} >از استان تهران (ترمینال غرب)</DirectionText>
                                </div>
                                <span className="d-none d-lg-block col-lg-6 mt-5" style={{width:"150px",borderTop:"1px #ccc dashed"}}></span>
                                <span className="d-block d-lg-none col-1 ml-12" style={{height:"7px",borderRight:"1px #ccc dashed"}}></span>
                                <div className="row col-lg-3 px-lg-0" style={{marginRight:"auto"}}>
                                    <Icon src={Ellipse}/>
                                    <DirectionText>به استان گیلان (ترمینال رشت)</DirectionText>
                                </div>
                            </div>
                            <Button className="ml-5 mt-5">مشاهده روی نقشه</Button>
                        </Direction>

                        <div className="mt-17 col-12">
                            <Title >ایباس به زودی در...</Title>
                        </div>
                        <Direction className="col-12 mt-17 mb-3">
                            <div className="row mt-5 mt-lg-0">
                                <span className="row col-lg-4 pl-lg-10">
                                    <Icon src={LocationGray} />
                                    <DirectionText style={{fontWeight:"bold"}} >از استان زنجان</DirectionText>
                                </span>
                                <span className="d-none d-lg-block col-lg-5 mt-5" style={{width:"150px",borderTop:"1px #ccc dashed"}}></span>
                                <span className="d-block d-lg-none col-1 ml-4" style={{height:"7px",borderRight:"1px #ccc dashed"}}></span>
                                <div className="row col-lg-3 px-0 marginFix">
                                    <Icon src={Ellipse}/>
                                    <DirectionText>به استان تهران</DirectionText>
                                </div>
                            </div>
                            <div className="row mt-5 mt-lg-0">
                                <span className="row col-lg-4 pl-lg-10">
                                    <Icon src={LocationGray} />
                                    <DirectionText style={{fontWeight:"bold"}} >از استان اردبیل</DirectionText>
                                </span>
                                <span className="d-none d-lg-block col-lg-5 mt-5" style={{width:"150px",borderTop:"1px #ccc dashed"}}></span>
                                <span className="d-block d-lg-none col-1 ml-4" style={{height:"7px",borderRight:"1px #ccc dashed"}}></span>
                                <div className="row col-lg-3 px-0 marginFix">
                                    <Icon src={Ellipse}/>
                                    <DirectionText>به استان تهران </DirectionText>
                                </div>
                            </div>
                            <div className="row mt-5 mt-lg-0">
                                <span className="row col-lg-4 pl-lg-10">
                                    <Icon src={LocationGray} />
                                    <DirectionText style={{fontWeight:"bold"}}>از استان آذربایجان شرقی</DirectionText>
                                </span>
                                <span className="d-none d-lg-block col-lg-5 mt-5" style={{width:"150px",borderTop:"1px #ccc dashed"}}></span>
                                <span className="d-block d-lg-none col-1 ml-4" style={{height:"7px",borderRight:"1px #ccc dashed"}}></span>
                                <div className="row col-lg-3 px-0 marginFix">
                                    <Icon src={Ellipse}/>
                                    <DirectionText>به استان تهران </DirectionText>
                                </div>
                            </div>
                        </Direction>
                        <div className="mt-10 col-12">
                            <Text>شهر بعدی که دوست دارید ایباس به اون جا بیاد کدومه ؟
                                <br></br>
                            برای ما بنویسید...
                            </Text>
                        </div>
                        <textArea 
                        className="mt-3 col-12 p-5" 
                        type="text" 
                        placeholder="نظرات خودتون رو برای ما بنویسید"
                        value={content}
                        onChange={(e) => {setContent(e.target.value)}}
                        style={{minHeight:"100px", borderRadius:"10px",outline:"none", border:"#ddd solid 1px"}} />
                        <Submit 
                            className="col-3 mt-5 mb-20"
                            onClick={() => {
                                setContent("")
                                setSubmitOpen(true)
                                window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                            }}
                            >ثبت نظر </Submit>
                        </div>

                </Container>
                
            </div>
            <Footer >و به زودی در سراسر ایران در 
            <br />  #فصل_جدید_سفر</Footer>
        </>
        }
    </>
    )
}

export default CityLanding